import { useCompanionNoun } from '@/utils/personalization'
import ContinueButton from '@app-studio-web/ui/components/ContinueButton'
import PageLayout from '@app-studio-web/ui/components/PageLayout'
import type { ReactNode } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'

type Props = {
  titleKey: string
  titleParams?: Record<string, string | number>
  subtitleKey: string
  subtitleParams?: Record<string, string | number>
  heroContent?: ReactNode
}

function ChatBubbleHero() {
  return (
    <div
      className="flex h-24 w-24 items-center justify-center rounded-full shadow-[0_8px_30px_rgba(45,45,45,0.18)]"
      style={{
        background: '#2D2D2D',
        animation: 'heartFloat 3.5s ease-in-out infinite',
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" className="h-11 w-11">
        <path
          d="M12 3C7.03 3 3 6.58 3 11c0 2.39 1.18 4.53 3.05 6v3.5a.5.5 0 0 0 .8.4l3.1-2.32c.66.13 1.35.2 2.05.2 4.97 0 9-3.58 9-8s-4.03-8-9-8Z"
          fill="white"
        />
        <circle cx="8.5" cy="11" r="1.1" fill="#2D2D2D" />
        <circle cx="12" cy="11" r="1.1" fill="#2D2D2D" />
        <circle cx="15.5" cy="11" r="1.1" fill="#2D2D2D" />
      </svg>
    </div>
  )
}

export default function FeedbackPage({
  titleKey,
  titleParams,
  subtitleKey,
  subtitleParams,
  heroContent,
}: Props) {
  const { i18n, t } = useTranslation()
  const noun = useCompanionNoun()
  const titleValues = { noun, ...titleParams }
  const subtitleValues = { noun, ...subtitleParams }

  return (
    <PageLayout>
      <div className="flex grow flex-col items-center justify-center gap-8 text-center">
        {heroContent ?? <ChatBubbleHero />}
        <h2
          className="text-primary max-w-xl font-serif text-3xl leading-tight font-normal wrap-break-word hyphens-auto"
          lang={i18n.resolvedLanguage || i18n.language}
        >
          {t(titleKey, titleValues)}
        </h2>
        <div className="text-muted max-w-xl text-base leading-relaxed">
          <Trans
            i18nKey={subtitleKey}
            values={subtitleValues}
            count={
              typeof subtitleParams?.count === 'number'
                ? subtitleParams.count
                : undefined
            }
            components={{
              bold: <strong className="text-primary font-bold" />,
            }}
          />
        </div>
      </div>

      <Form className="shrink-0" method="post">
        <input
          name="feedback"
          type="hidden"
          value={t(titleKey, { ...titleValues, lng: 'en' })}
        />
        <ContinueButton />
      </Form>
    </PageLayout>
  )
}
